import * as React from 'react';
import StartComponent from 'src/modules/commons/start/Start.component';
import QuestionComponent from 'src/modules/faq/Question.component';

const FaqComponent: React.StatelessComponent = () => (
  <section>
    <div className="container">

      <div className="row">
        <div className="col-md-8">
          <h1 className="bold-title">
            Preguntas frecuentes
          </h1>
          <div className="gap-20"/>
        </div>
        <div className="col-md-4">
          <p className="breadcrumb text-right">
            Inicio > Preguntas frecuentes
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <div className="faq-box">
            <h3>
              Registro
            </h3>
            <div className="gap-20"/>
            <div className="faqAccordion">
              <QuestionComponent
                questionId={38}
                question="¿Tiene algún coste formar parte de The Crowd Angel?"
                answer={
                  `No. The Crowd Angel es de acceso gratuito para todos los usuarios y no hay que pagar ninguna cuota.`
                }
              />
              <QuestionComponent
                questionId={39}
                question="¿Es confidencial la información que veo?"
                answer={
                  `Sí. Al registrarte aceptas el documento <a href="/terminos-y-condiciones">Terms & Conditions</a> en
                    el cual se comunica que toda la información mostrada en The Crowd Angel es confidencial y no se
                    puede mostrar o compartir con personas ajenas a la plataforma.`
                }
              />
            </div>
          </div>
          <div className="gap-50"/>

          <div className="faq-box">
            <h3 >
              Una vez invertido
            </h3>
            <div className="gap-20"/>
            <div className="faqAccordion">
              <QuestionComponent
                questionId={20}
                question="¿Cómo puedo hacer el seguimiento de mi inversión?"
                answer={
                  `The Crowd Angel emitirá informes de seguimiento trimestralmente sobre la evolución de la compañía y
                  el cumplimiento de los objetivos. Además, una vez hayas invertido en una compañía, tendrás acceso a
                  una ficha de la misma en el apartado "Mis Inversiones".`
                }
              />
              <QuestionComponent
                questionId={21}
                question="¿Existe un plazo mínimo para mantener la inversión?"
                answer={
                  `No. Desde The Crowd Angel no ponemos trabas a la transmisibilidad. Ahora bien, el proceso de venta de
                   tus participaciones deberá cumplir, en cualquier caso, con los requisitos previstos al efectos en el
                    Pacto de socios  y en la Ley de Sociedades de Capital. Recuerda que la inversión en el capital de
                     empresas privadas es un activo con poca liquidez, así que no inviertas capital que puedas necesitar
                      en el corto plazo.`
                }
              />
              <QuestionComponent
                questionId={22}
                question="¿Cuánto tiempo dura el seguimiento de la participada?"
                answer={
                  `En The Crowd Angel hacemos seguimiento de la participada hasta el momento en que los inversores
                  desinvierten de la misma.`
                }
              />
              <QuestionComponent
                questionId={23}
                question="¿Tienen liquidez las participaciones compradas a través de The Crowd Angel?"
                answer={
                  `No. Debido a la legislación actual no podemos ofrecer liquidez. No obstante, los documentos legales
                  firmados han sido redactados de manera que no limitan ni impiden la transmisibilidad de las
                  participaciones.`
                }
              />
              <QuestionComponent
                questionId={24}
                question="¿Cómo afecta la desinversión al acuerdo de sindicación?"
                answer={
                  `Una vez desinvierten todos los Crowd Angels , el acuerdo de sindicación queda sin efecto.`
                }
              />
            </div>
          </div>

          <div className="gap-50"/>

          <div className="faq-box">
            <h3>
              Emprendedores
            </h3>
            <div className="gap-20"/>
            <div className="faqAccordion">
              <QuestionComponent
                questionId={25}
                question="¿Cómo puedo obtener financiación para mi empresa?"
                answer={
                  `Una vez registrado, ve al apartado “Emprendedores”. Completa un pequeño formulario para ver si tu
                  empresa cumple con nuestro requisitos mínimos para evaluar la posibilidad de inversión y envíanos tu
                  presentación para inversores. `
                }
              />
              <QuestionComponent
                questionId={26}
                question="¿Qué requisitos debe cumplir mi empresa para poder ser publicada en The Crowd Angel?"
                answer={
                  `Tiene que ser una empresa de base tecnológica o con modelo de negocio innovador, escalable, con alto
                  potencial de crecimiento y que haya demostrado que satisface una necesidad existente en el mercado.
                  Para más información sobre los criterios de selección de las empresas que se publican, puedes
                  consultar en <a href="/como-financiar-tu-startup">“Emprendedores”</a> `
                }
              />
              <QuestionComponent
                questionId={27}
                question={`¿Cuánto tiempo pasa desde que envío la presentación a inversores hasta que se publica la
                ronda en la web?`}
                answer={
                  `El envío de la presentación a inversores es sólo la primera fase del proceso de selección y análisis,
                   que consistirá en el análisis de la documentación aportada, una o más reuniones presenciales,
                   aportación de documentación adicional, negociación de las condiciones de la ronda y preparación de
                   la documentación para la publicación. El proceso entero tiene una duración variable, pero normalmente
                    es entre cuatro y seis semanas.`
                }
              />
              <QuestionComponent
                questionId={28}
                question="¿Puedo presentar una operación si la empresa aún no está creada?"
                answer={
                  `No. La empresa debe estar constituida y operativa.`
                }
              />
              <QuestionComponent
                questionId={29}
                question="¿Tengo que pasar alguna selección?"
                answer={
                  `Sí. The Crowd Angel analiza todas las empresas que recibe y sólo presenta aquellas que además de
                  cumplir con los criterios de selección, presentan un alto potencial de crecimiento y se llega a un
                  acuerdo en las condiciones de la inversión para que ésta sea atractiva para los inversores.`
                }
              />
              <QuestionComponent
                questionId={30}
                question="¿Durante cuánto tiempo se publica una operación?"
                answer={
                  `El plazo por defecto para conseguir el capital es de dos meses. Sin embargo, la operación se cerrará
                  en el momento en que se consiga el 125% del objetivo de inversión, aunque no haya terminado el plazo
                  de la inversión.`
                }
              />
              <QuestionComponent
                questionId={31}
                question="¿Qué pasa en el momento en que se cubre el importe objetivo?"
                answer={
                  `Si se ha realizado la Due Diligence y ha salido sin salvedades mayores, se ponen a disposición de los
                   inversores los documentos legales necesarios para formalizar la operación, debiendo ser los mismos
                   revisados, firmados y enviados de vuelta en el plazo máximo de cinco días. Una vez la documentación
                   está completa y revisada, se procede con el desembolso y la escrituración de la ampliación de
                   capital.`
                }
              />
              <QuestionComponent
                questionId={32}
                question="¿Qué pasa si a mitad del proceso encuentro un inversor externo?"
                answer={
                  `The Crowd Angel no te pide exclusiva. Lo que sí te exige es que mantengas el capital que ya se haya
                  comprometido a través de la plataforma. En cuanto al inversor externo, puede registrarse e invertir a
                  través de The Crowd Angel, y así aprovechar las ventajas que ofrecemos tanto en la estructuración como
                   en el seguimiento de la inversión.
                   <br>
                    Dependiendo de la cantidad invertida respecto al total de la ronda de inversión, este inversor
                 externo no estará sujeto a las condiciones de inversión negociadas por el resto de Crowd Angels en el
                 pacto de socios.`
                }
              />
              <QuestionComponent
                questionId={33}
                question="¿Qué pasa si el importe objetivo no se cubre?"
                answer={
                  `En tal caso, The Crowd Angel retirará la publicación cuando exceda el plazo de los dos meses,  y se
                  lo comunicará al emprendedor y a los  inversores comprometidos. Automáticamente quedarán cancelados
                  todos los compromisos de inversión y, en caso de que se hayan realizado transferencias, éstas serán
                  devueltas en el plazo máximo de 15 días.`
                }
              />
              <QuestionComponent
                questionId={34}
                question="¿Cómo se canaliza la inversión de los Crowd Angels a mi empresa?"
                answer={
                  `Los Crowd Angels compran participaciones directamente en la empresa, y sindican su inversión a través
                   de un contrato privado de sindicación.`
                }
              />
              <QuestionComponent
                questionId={35}
                question="¿Puedo invertir en mi propia empresa?"
                answer={
                  `Sí. De hecho muchos inversores ven como una muestra de compromiso que el emprendedor participe en las
                   rondas de financiación.`
                }
              />
              <QuestionComponent
                questionId={36}
                question="¿Qué coste tiene publicar mi empresa en The Crowd Angel?"
                answer={
                  `La publicación como tal no tiene coste. Sólo en caso de cerrar con éxito la ronda de inversión, The
                  Crowd Angel cobrará una "fee" de estructuración, y un “fee” de seguimiento correspondiente a la
                  gestión post-inversión.`
                }
              />
              <QuestionComponent
                questionId={37}
                question="¿Quién asume el coste de la Due Diligence?"
                answer={
                  `El coste de la Due Diligence lo asume la propia compañía, hasta un máximo de 3.000€. Sin embargo,
                  este coste no se llevará a cabo hasta que no se haya llegado al 90% del objetivo de inversión, y por
                  la entrada de capital en la compañía esté asegurada.`
                }
              />
            </div>
          </div>

        </div>

        <div className="col-sm-6">
          <div className="faq-box">
            <h3>
              Inversores
            </h3>
            <div className="gap-20"/>
            <div className="faqAccordion">
              <QuestionComponent
                questionId={0}
                question="¿Tengo que ser residente español para poder invertir en The Crowd Angel?"
                answer={
                  `No es necesario ser residente, pero para poder invertir y usar todas las funcionalidades de la
                  plataforma, tal y como contempla la Ley de Sociedades del Capital para inversiones en Sociedades
                  Limitadas españolas, vas a necesitar un documento de identidad vigente en España (DNI o NIE -Número de
                   Identificación de Extranjeros-).`
                }
              />
              <QuestionComponent
                questionId={1}
                question="¿Las empresas en las que puedo invertir son todas españolas?"
                answer={
                  `De momento sí, pero en un futuro podríamos dar entrada a empresas extranjeras, siempre y cuando se
                  encuentren registradas en otro Estado miembro de la Unión Europea y dentro del espacio Schengen.`
                }
              />
              <QuestionComponent
                questionId={2}
                question="Cuando invierto, ¿estoy invirtiendo directamente en el capital de la empresa?"
                answer={
                  `En las operaciones catalogadas como “Capital”, sí, estás adquiriendo participaciones de la
                      empresa en la que inviertes, por tanto, te conviertes en socio de la misma adquiriendo los
                      derechos que se desprenden de la Ley de Sociedades de Capital.
                      <br>
                      En las operaciones catalogadas como “Préstamo Convertible”, se está haciendo un préstamo
                    a la compañía que contempla un periodo y unas condiciones concretas para convertirse a inversión en
                      capital, pero las participaciones no se están adquiriendo de forma inmediata.`
                }
              />
              <QuestionComponent
                questionId={3}
                question="¿Tengo ventajas fiscales al invertir en empresas de reciente creación?"
                answer={
                  `Sí, en España existen existen distintos tipos de incentivos y ventajas fiscales relacionadas con
                      la inversión en el capital de empresas de reciente creación, tanto a nivel nacional como regional.
                       Consulta nuestra
                       <a href="http://blog.thecrowdangel.com/blog/crowd-angel-guia-deducciones-fiscales/">
                       Guía de deducciones fiscales
                       </a> para conocer las deducciones a las
                        que te puedes acoger tanto a nivel nacional como de comunidad autónoma.
                        <br>
                        Sin perjuicio de lo anterior, una vez registrado en nuestra plataforma, y llegado el momento
                de invertir, te informaremos sobre cuales son las ventajas fiscales que podrían resultar aplicables
                      en cada caso concreto y, posteriormente, con carácter previo a la Campaña de la Renta, te haremos
                       llegar el correspondiente certificado para posibles deducciones fiscales.`
                }
              />
              <QuestionComponent
                questionId={4}
                question="¿Puedo invertir a través de una sociedad?"
                answer={
                  `Sí, siempre y cuando ostentes facultades suficientes para representarla y firmar en su
                      representación. En este este caso, además del documento de identidad vigente en España del
                      representante de la compañía, te pediremos el NIF de la empresa (Número de Identificación Fiscal),
                       tanto si se trata de una compañía española o como si no, en cuyo caso deberás solicitarlo. `
                }
              />
              <QuestionComponent
                questionId={5}
                question="¿Puedo deshacer mi compromiso de inversión antes de que se cierre la operación?"
                answer={
                  `Si, pero serás penalizado con el pago del importe equivalente al 10% sobre la cantidad
                      comprometida, con el límite de 1.000 euros. `
                }
              />
              <QuestionComponent
                questionId={6}
                question="¿Cuál es el mínimo y el máximo que puedo invertir?"
                answer={
                  `El mínimo son 3.000€ (un ticket) y el máximo es el indicado en el rango de ampliación de cada
                      operación que se presenta (si quisieras, podrías comprar todos los tickets disponibles). También
                      influye el tipo de inversor con el cual inviertes, si no eres un inversor acreditado, el límite
                      por ley, son 3.000€ por operación y 10.000€ anuales. Los inversores acreditados no tendrán límites
                       a la inversión. `
                }
              />
              <QuestionComponent
                questionId={7}
                question="¿El valor de un ticket es siempre de 3.000 €?"
                answer={
                  `Sí, todas las operaciones se dividen en tickets de 3.000 € para dar homogeneidad y facilitar
                      la futura valoración de los tickets. `
                }
              />
              <QuestionComponent
                questionId={8}
                question="¿Puedo tener contacto directo con el emprendedor?"
                answer={
                  `Sí, a través de The Crowd Angel puedes enviar mensajes directamente al emprendedor a través del
                      canal de “Comentarios” que encontrarás en la ficha de cada operación. A través de este canal,
                      también tendrás acceso a los mensajes que han enviado los demás inversores y las respuestas del
                      emprendedor.`
                }
              />
              <QuestionComponent
                questionId={9}
                question="¿Qué pasa si, cumplido el plazo de publicación, una operación no se completa?"
                answer={
                  `Si la operación en financiación no alcanza al menos el 90% de la cantidad objetivo una vez
                      transcurrido el periodo máximo para poder participar en el mismo, la inversión se considerará
                      fallida y, por tanto, quedará cancelada sin efectos. Esto implica, pues, que todos los compromisos
                       de inversión quedarán automáticamente cancelados y, en caso de que se haya efectuado alguna
                       transferencia, esta será devueltas en el plazo máximo de 15 días.`
                }
              />
              <QuestionComponent
                questionId={10}
                question="¿Puedo formar parte del Consejo de Administración de la empresa en la que invierto?"
                answer={
                  `Sí, en el momento de invertir te pedimos si quieres ser candidato para formar parte del Consejo
                      de Administración de la empresa en la que vas a invertir. Normalmente habrá una plaza reservada
                      para los inversores de The Crowd Angel y, en caso de que haya más solicitantes que plazas, se hará
                       una votación entre los distintos inversores, teniendo preferencia aquéllos que representen un
                       porcentaje más elevado de la inversión.`
                }
              />
              <QuestionComponent
                questionId={11}
                question="¿En algún momento se lleva a cabo una Due Diligence?"
                answer={
                  `Sí. Tras la publicación de la operación, y una vez que se hayan obtenido los compromisos de
                      inversión necesarios para alcanzar el 75% de la inversión, se lleva a cabo una Due Diligence
                      financiera, fiscal, legal y laboral de la empresa. Si el resultado es positivo, la inversión se
                      materializa; si por el contrario, es negativo, los Crowd Angels tendrán que valorar los aspectos
                      negativos y decidir si quieren seguir con la inversión.`
                }
              />
              <QuestionComponent
                questionId={12}
                question="¿Qué coste tiene invertir a través de The Crowd Angel?"
                answer={
                  `Como inversor, tendrás que pagar un corretaje del 2% + IVA, sobre el importe que inviertas en
                      cada operación, y un 10% + IVA , sobre las plusvalías en el momento de la desinversión.`
                }
              />
              <QuestionComponent
                questionId={13}
                question="¿En qué momento tengo que hacer la aportación de capital?"
                answer={
                  `Al aceptar tu compromiso de inversión y confirmar la inversión comprometida tras el análisis y
                      aceptación de los resultados obtenidos con la realización de la Due Diligence, ya se procederá con
                       la transferencia. Para ello, una vez esté disponible la opción de poder hacer la aportación, se
                       te facilitará la cuenta bancaria a la que realizar la transferencia del importe comprometido.`
                }
              />
              <QuestionComponent
                questionId={14}
                question="¿Cómo se realiza la aportación de capital?"
                answer={
                  `Se realiza a través de nuestra plataforma de pagos híbrida Mangopay.`
                }
              />
              <QuestionComponent
                questionId={15}
                question="¿Tiene algún riesgo mi inversión?"
                answer={
                  'Sí. Invertir en operaciones emprendedoras en fases iniciales puede reportar mayores retornos que ' +
                  'otros activos, pero a la vez conlleva un riesgo mayor  Para ver los riesgos que implican este tipo' +
                  ' de inversión, te invitamos a leer nuestro apartado de ' +
                  '<a href=\"/informacion-basica#riesgos\">riesgos</a>'
                }
              />
              <QuestionComponent
                questionId={16}
                question="¿Qué documentos se necesitan para formalizar la inversión?"
                answer={
                  `Existen dos documentos legales que deben ser firmados para formalizar la inversión a través de The
                  Crowd Angel: i) Pacto de socios de la compañía en la que inviertes y, ii) Acuerdo de sindicación.
                  En algunas operaciones puede que se tengan que firmar más documentos, todo depende de cómo se articule
                   la operación con los otros co-inversores, al momento de formalizar os indicaremos los documentos
                   totales a firmar.`
                }
              />
              <QuestionComponent
                questionId={17}
                question="¿Dónde puedo ver los documentos legales?"
                answer={
                  `Una vez registrado, accede a la ficha de cualquier operación que esté en periodo de financiación y
                  allí podrás consultar las plantillas de los documentos estandarizados que utilizamos en las
                  operaciones de inversión.`
                }
              />
              <QuestionComponent
                questionId={18}
                question="¿Puedo echarme atrás una vez he comprometido mi inversión?"
                answer={
                  `Si, pero serás penalizado con el pago del importe equivalente al 10% sobre la cantidad comprometida,
                   con el límite de 1.000 euros. `
                }
              />
              <QuestionComponent
                questionId={19}
                question="¿Cómo se firman los contratos?"
                answer={
                  `Una vez tengamos las versiones finales, las remitiremos para firmar desde Signaturit (plataforma de
                  firmas que no requiere que tengáis firma digital). Os llegará por separado la firma de cada
                  documento. `
                }
              />
            </div>
          </div>

          <div className="gap-50"/>
        </div>
      </div>

    </div>
    <StartComponent/>
  </section>
);

export default FaqComponent;



// WEBPACK FOOTER //
// ./src/modules/faq/Faq.component.tsx